import { render, staticRenderFns } from "./AccountModal.vue?vue&type=template&id=b63a86ec&scoped=true&"
import script from "./AccountModal.vue?vue&type=script&lang=ts&"
export * from "./AccountModal.vue?vue&type=script&lang=ts&"
import style0 from "./AccountModal.vue?vue&type=style&index=0&id=b63a86ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63a86ec",
  null
  
)

export default component.exports